// Toggle actions
export const SET_TOGGLE_STATE = 'SET_TOGGLE_STATE'

/**
 * Actualiza el estado de un toggle específico
 * @param {string} toggleId - Identificador único del toggle (ej: 'squad-body', 'stats-body')
 * @param {boolean} active - Estado activo/inactivo del toggle
 */
export function setToggleState(toggleId, active) {
  return {
    type: SET_TOGGLE_STATE,
    payload: {
      toggleId,
      active
    }
  }
}



// WEBPACK FOOTER //
// ./src/actions/toggles.js